import { AxiosError } from 'axios'
import apiClient from '../../../services/api-client'
import { fixProductVariantSpacing } from './fixProductVariantNumber'
import { DimensionTypes, VariantResponse } from './useVariations'

export type ProductVariant = {
  size: string | undefined
  colour: string | undefined
  productId: number | undefined
}

export const getDefaultProduct = async (
  masterProductId: string,
  size: string,
  colour: string,
): Promise<ProductVariant | undefined> => {
  try {
    const response = await apiClient.get<VariantResponse, AxiosError>(
      `/products/${masterProductId}/variants`,
    )

    if (response.status.toString().startsWith('2')) {
      const data = response.data
      if (data) {
        data.variants.forEach((variant) => {
          variant.productVariantNumber = fixProductVariantSpacing(variant.productVariantNumber)
        })
        data.variants.sort(
          (a, b) => (a.dimensions[0].displayOrder ?? 0) - (b.dimensions[0].displayOrder ?? 0),
        )

        //1. Find size and colour from the variants list
        let selectedSize: string | undefined = data.variants
          .find((v) => v.dimensions.find((x) => x.type === DimensionTypes.SIZE)?.value === size)
          ?.dimensions.find((x) => x.type === DimensionTypes.SIZE)?.value

        let selectedColour: string | undefined = data.variants
          .find((v) => v.dimensions.find((x) => x.type === DimensionTypes.COLOUR)?.value === colour)
          ?.dimensions.find((x) => x.type === DimensionTypes.COLOUR)?.value

        //2. Set the default variant as the first one in the variants list
        if (!selectedSize) {
          selectedSize = data.variants[0].dimensions.find(
            (x) => x.type === DimensionTypes.SIZE,
          )?.value
        }

        if (!selectedColour) {
          selectedColour = data.variants[0].dimensions.find(
            (x) => x.type === DimensionTypes.COLOUR,
          )?.value
        }

        //3. Get productId based on selected size and colour
        const productId = data.variants.find(
          (v) =>
            v.dimensions.find((x) => x.type === DimensionTypes.SIZE)?.value === selectedSize &&
            v.dimensions.find((x) => x.type === DimensionTypes.COLOUR)?.value === selectedColour,
        )?.productId

        return {
          size: selectedSize,
          colour: selectedColour,
          productId,
        }
      }
    }
  } catch (error) {
    console.log('error', error)
  }
}
